import type { PropsWithChildren, ReactNode } from 'react';

import { TabPaneStyled } from './styles/TabPaneStyled'

export interface ITabPaneProps {
  label: ReactNode
  key: string
}

export const TabPane = ({
  children,
}: PropsWithChildren<ITabPaneProps>) => {
  return <TabPaneStyled>{children}</TabPaneStyled>
}

TabPane.displayName = 'TabPane'
